import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import { DashboardRejectionGroupViewModel } from '../../ViewModels';

/**
 * API for DashboardRejectionGroup, which is a grouping of validation failure types used by dashboard queries.
 */
export class DashboardRejectionGroupApi {
    private route = '/DashboardRejectionGroup';

    public getDashboardRejectionGroups = (): ApiResponse<DashboardRejectionGroupViewModel[]> => {
        return api().get(`${this.route}`);
    };

    public getDashboardRejectionGroup = (id: number): ApiResponse<DashboardRejectionGroupViewModel[]> => {
        return api().get(`${this.route}/${id}`);
    };

    public postDashboardRejectionGroup = (data: DashboardRejectionGroupViewModel): ApiResponse<number> => {
        return api().post(`${this.route}`, data);
    };

    public putDashboardRejectionGroup = (id: number, data: DashboardRejectionGroupViewModel): ApiResponse<number> => {
        return api().put(`${this.route}/${id}`, data);
    };

    public deleteDashboardRejectionGroup = (id: number): ApiResponse<void> => {
        return api().delete(`${this.route}/${id}`);
    };
}
